import {
  ROUTER_COMPANYS_DETAIL,
  ROUTER_COMPANY_LIST,
  ROUTER_COMPANY_SUCCESS,
  ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING,
  ROUTER_CARBON_CORPORATE,
  ROUTER_CARBON_EMISSION_ACCOUNT_INSTITUTION,
  ROUTER_CARBON_EMISSION_ACCOUNT_NON_PROJECT_LOAN,
  ROUTER_CARBON_EMISSION_ACCOUNT_PROJECT_LOAN,
  ROUTER_CARBON_EMISSION_ACCOUNT_TRADING,
  ROUTER_CARBON_REDUCTION_ACCOUNT_NON_PROJECT_LOAN,
  ROUTER_CARBON_REDUCTION_ACCOUNT_PROJECT_LOAN,
  ROUTER_COMPANY_DETAIL,
  ROUTER_COMPANY_DETAIL_PREFIX,
  ROUTER_CORPORATE,
  ROUTER_CREATE_PROJECT,
  ROUTER_ENV_INFORMATION_DISCLOSURE,
  ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL,
  ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID,
  ROUTER_HOME,
  ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL,
  ROUTER_PROJECT_LIBRARY,
  ROUTER_PROJECT_LIBRARY_DETAIL,
  ROUTER_QUESTIONAIRE,
  ROUTER_QUESTIONAIRE_DETAIL,
  ROUTER_RISK_SURVEY,
  ROUTER_SCREENING,
  ROUTER_STATISTICS_REPORT,
  ROUTER_STATISTICS_SCREEN,
  ROUTER_WATCHLIST,
  ROUTER_WATCHLIST_DETAIL,
} from "./router";

export const routeAccess: {
  [property: string]: any;
} = {
  [ROUTER_HOME]: '/home',
  [ROUTER_SCREENING]: '/home',
  [ROUTER_WATCHLIST]: '/watchlist', // 客户名单管理列表
  [ROUTER_WATCHLIST_DETAIL]: '/watchlist', // 客户名单详情
  [ROUTER_COMPANY_DETAIL_PREFIX]: '/home', // 企业高级搜索页
  [ROUTER_COMPANY_DETAIL]: '/home', // 企业详情页
  // 企业库
  [ROUTER_PROJECT_LIBRARY]: '/project-library',
  [ROUTER_PROJECT_LIBRARY_DETAIL]: '/project-library',
  // 风险管理
  [ROUTER_QUESTIONAIRE]: '/esg-risk-dd/questionaire-list',
  [ROUTER_RISK_SURVEY]: '/esg-risk-dd/questionaire-list',
  [ROUTER_QUESTIONAIRE_DETAIL]: '/esg-risk-dd/questionaire-list',

  // 对公信贷业务（绿色信贷管理）
  [ROUTER_CORPORATE]: '/corporate', // 对公信贷业务（绿色信贷管理）
  [ROUTER_CREATE_PROJECT]: ['/corporate', '/carbon-account-management/project-loan', '/carbon-account-management/non-project-loan'],
  [ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL]: ['/corporate', '/carbon-account-management/project-loan', '/carbon-account-management/non-project-loan','/carbon-account-management/trading', '/carbon-account-management/consumption'],
  [ROUTER_CARBON_CORPORATE]: ['/carbon-account-management/project-loan', '/carbon-account-management/non-project-loan'],
  // 碳核算管理
  // 机构碳核算
  [ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION]: '/carbon-account-management/institution',
  [ROUTER_CARBON_EMISSION_ACCOUNT_INSTITUTION]: '/carbon-account-management/institution',
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION]: '/carbon-account-management/institution',
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING]: '/carbon-account-management/trading',
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION]: '/carbon-account-management/consumption',
  [ROUTER_CARBON_EMISSION_ACCOUNT_TRADING]: '/carbon-account-management/trading',

  // 项目碳核算
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN]: '/carbon-account-management/project-loan',
  [ROUTER_CARBON_EMISSION_ACCOUNT_PROJECT_LOAN]: '/carbon-account-management/project-loan',
  [ROUTER_CARBON_REDUCTION_ACCOUNT_PROJECT_LOAN]: '/carbon-account-management/project-loan',
  // 非项目
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN]: '/carbon-account-management/non-project-loan',
  [ROUTER_CARBON_EMISSION_ACCOUNT_NON_PROJECT_LOAN]: '/carbon-account-management/non-project-loan',
  [ROUTER_CARBON_REDUCTION_ACCOUNT_NON_PROJECT_LOAN]: '/carbon-account-management/non-project-loan',
  //排放源
  [ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE]: '/carbon-account-management/emission-source',

  // 绿色金融业务统计
  [ROUTER_STATISTICS_SCREEN]: '/statistics/screen',
  [ROUTER_STATISTICS_REPORT]: '/statistics/report',

  // 信息披露
  [ROUTER_ENV_INFORMATION_DISCLOSURE]: '/env-information-disclosure',
  [ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL]: '/env-information-disclosure',
  [ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID]: '/env-information-disclosure',

  // 授信客户
  [ROUTER_COMPANY_LIST]: '/company-list',
  [ROUTER_COMPANYS_DETAIL]: '/company-list',
  [ROUTER_COMPANY_SUCCESS]: '/company-list',

  // data collection platform
  // [ROUTER_DATA_COLLECTION_PLATFORM_SME]: '/data-collection-platform',
};

